import * as React from 'react';

type Props = {
  locale: 'sv-SE';
  amount: number;
};

const MONEY_NAME = {
  'sv-SE': {
    prepend: '',
    append: ' kr',
  },
};

export function Amount(props: Props) {
  const localeAmount = props.amount.toLocaleString(props.locale);
  const localeMoneyName = MONEY_NAME[props.locale];

  return (
    <React.Fragment>
      {localeMoneyName.prepend}
      {localeAmount}
      {localeMoneyName.append}
    </React.Fragment>
  );
}
